import { useTranslation } from 'react-i18next';
import { LANGUAGES } from '../../constants/languages';

const LanguageSwitcher = ({ className = '', selectClassName = '' }) => {
  const { i18n, t } = useTranslation();

  return (
    <label className={`inline-flex items-center gap-2 text-sm ${className}`}>
      <span className="sr-only">{t('language.label')}</span>
      <select
        value={i18n.language}
        onChange={(e) => i18n.changeLanguage(e.target.value)}
        aria-label={t('language.label')}
        className={`rounded-lg border border-zinc-300 bg-white px-2 py-1.5 text-sm text-zinc-800 outline-none focus:border-glow-500 dark:border-zinc-700 dark:bg-zinc-900 dark:text-zinc-100 ${selectClassName}`}
      >
        {LANGUAGES.map(({ code, labelKey }) => (
          <option key={code} value={code}>
            {t(labelKey)}
          </option>
        ))}
      </select>
    </label>
  );
};

export default LanguageSwitcher;
